<template>
  <div class="public-calendar">
    <header class="public-calendar__bar">
      <div class="public-calendar__brand">
        <img v-if="business && business.imageUrl" :src="business.imageUrl" :alt="business.name" />
        <div><strong>{{ business ? business.name : "Academic calendar" }}</strong><span v-if="year">{{ year.Class.name }} · {{ year.name }}</span></div>
      </div>
      <div class="public-calendar__actions">
        <v-btn text color="primary" :disabled="!definition" @click="print"><v-icon left>mdi-printer-outline</v-icon>Print</v-btn>
        <v-btn color="primary" depressed :disabled="!definition" @click="download"><v-icon left>mdi-download-outline</v-icon>Download PDF</v-btn>
      </div>
    </header>
    <main class="public-calendar__preview">
      <iframe v-if="pdfUrl" :src="viewerUrl" title="Published academic calendar" />
      <div v-else-if="loading" class="public-calendar__state"><v-progress-circular indeterminate color="primary" /><strong>Loading calendar...</strong></div>
      <div v-else class="public-calendar__state"><v-icon size="54" color="grey lighten-1">mdi-calendar-remove-outline</v-icon><strong>Calendar unavailable</strong><span>{{ error }}</span></div>
    </main>
  </div>
</template>

<script>
import publicService from "./service";
import { buildCalendarPdfDefinition, calendarPdf } from "@/modules/ReportCard/Year/calendarPdf";

export default {
  name: "public-academic-calendar",
  data() { return { loading: true, error: "This link may be invalid or no longer available.", year: null, business: null, definition: null, pdfUrl: null }; },
  async created() {
    document.title = "Academic Calendar";
    try {
      const response = await publicService.getCalendar(this.$route.params.token);
      const data = response.data;
      this.year = data.year;
      this.business = data.business;
      this.definition = await buildCalendarPdfDefinition({ year: data.year, events: data.events || [], business: data.business || {} });
      await new Promise((resolve) => calendarPdf(this.definition).getBlob((blob) => { this.pdfUrl = URL.createObjectURL(blob); resolve(); }));
      document.title = `${this.year.Class.name} Calendar - ${this.year.name}`;
    } catch (error) {
      this.error = error?.data?.message || error?.response?.data?.message || "This calendar link is invalid or unavailable.";
    } finally { this.loading = false; }
  },
  beforeDestroy() { if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl); },
  methods: {
    print() { if (this.definition) calendarPdf(this.definition).print(); },
    download() { if (this.definition) calendarPdf(this.definition).download(`${this.year.name.replace(/[^a-z0-9]+/gi, "-")}-calendar.pdf`); },
  },
  computed: {
    viewerUrl() { return this.pdfUrl ? `${this.pdfUrl}#toolbar=1&navpanes=0&view=FitH` : ""; },
  },
};
</script>

<style scoped>
.public-calendar { display: flex; min-height: 100vh; flex-direction: column; background: #525659; }
.public-calendar__bar { display: flex; min-height: 72px; padding: 10px 24px; align-items: center; justify-content: space-between; background: #fff; box-shadow: 0 2px 8px rgba(0, 0, 0, .16); }
.public-calendar__brand { display: flex; min-width: 0; align-items: center; gap: 12px; color: #253047; }
.public-calendar__brand img { width: 46px; height: 46px; object-fit: contain; }
.public-calendar__brand div { display: flex; min-width: 0; flex-direction: column; }
.public-calendar__brand strong { font-size: 18px; }
.public-calendar__brand span { color: #718078; font-size: 13px; }
.public-calendar__actions { display: flex; gap: 8px; }
.public-calendar__preview { height: calc(100vh - 72px); padding: 16px; }
.public-calendar__preview iframe { width: 100%; height: 100%; border: 0; background: #fff; }
.public-calendar__state { display: flex; height: 100%; flex-direction: column; align-items: center; justify-content: center; gap: 10px; color: #fff; text-align: center; }
@media (max-width: 600px) {
  .public-calendar__bar { padding: 8px 12px; align-items: flex-start; flex-direction: column; gap: 8px; }
  .public-calendar__actions { width: 100%; justify-content: flex-end; }
  .public-calendar__preview { height: calc(100vh - 126px); padding: 6px; }
}
</style>
